<div class="d-inline-block"
     ngbDropdown
     [autoClose]="'outside'">
  <button type="button"
          class="btn btn-link text-primary p-0 dropdown-toggle"
          ngbDropdownToggle
          data-testid="device-category-type-filter">
    {{ selectionLabel() }}
  </button>
  <div ngbDropdownMenu>
    @for (option of options; track option.type) {
      <label class="dropdown-item d-flex align-items-center gap-2"
             role="menuitemcheckbox"
             [attr.aria-checked]="isSelected(option.type)">
        <input class="form-check-input mt-0"
               type="checkbox"
               [checked]="isSelected(option.type)"
               (change)="toggle(option.type)" />
        <span>{{ option.title }}</span>
      </label>
    }
  </div>
</div>